import { ClientInferRequest } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type CreateCompanyDto = ClientInferRequest<typeof contract.company.create>["body"];

export const createCompanyApi = async (company: CreateCompanyDto) => {
  const payload = {
    ...company,
  };

  const response = await api.company.create.mutation({
    body: payload,
  });

  if (response.status === 201) {
    return response.body;
  }

  throw new ApiError("Failed to create Company", response.status, response.body);
};
